<div class="confirm-dialog">
  <h2 mat-dialog-title>{{data?.title}}</h2>
  <div class="inner">
    <button [mat-dialog-close]="false" aria-label="Close" class="dialog__close-btn close-button">
      <i class="fa fa-times">close</i>
    </button>
    <div mat-dialog-content [align]="'center'" >
      <span style="white-space: pre-line; line-height: 30px">{{data?.message}}</span>
    </div>
    <div mat-dialog-actions [align]="'end'">
      <button class="confirm-dialog-button-cancel" mat-raised-button [mat-dialog-close]="false">{{data?.cancelText}}</button>
      <button class="confirm-dialog-button-confirm" mat-raised-button color="primary" [mat-dialog-close]="true">{{data?.confirmText}}</button>
    </div>
  </div>
</div>
<div class="overlay" ></div>
